<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a text editor
    *
    * @since 20200421
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div :style="style">
        <input type="hidden" :name="name" :value="valueActual">
        <!--<ckeditor ref="editor" :name="name" :value="value" v-on:input="update_value($event)" :config="config"></ckeditor>-->
        <jodit-editor :value="value" v-on:input="update_value($event)" :buttons="buttons" :config="config" :plugins="plugins" />
    </div>
</template>

<script>
import 'jodit/build/jodit.min.css'
import { JoditEditor } from 'jodit-vue'
    export default{
        components: { JoditEditor },
        props: {
            //the name of the editor
            name: {
                type: String,
                default: ''
            },
            //the value of the editor
            value: {
                type: String,
                default: ''
            },
            //the toolbar
            toolbar: {
                type: String,
                default: 'Basic'
            },
            //the height in pixels
            height: {
                default: -1
            },
            //the width in pixels
            width: {
                default: -1
            },
        },
        data() {
            return {
                valueActual: this.value,
            };
        },
        computed: {
            /**
             * gets the style of the outer div to set the width of the element
             * @returns object the style
             */
            style: function(){
                var sty = {};
                if(this.width > 0){
                    sty.width = this.width + 'px';
                }
                return sty;
            },
            /**
             * gets the height of the object, with a default value
             * @returns int the height in pixels
             */
            height_actual: function(){
                var hei = 200;
                if(this.height > 0){
                    hei = this.height;
                }
                return hei;
            },
            /**
             * gets the config options for the ckeditor
             * @returns object the config
             */
            config: function (){
                return {
                    license: '4118X-3UH73-CWLPN-SN7DY',
                    enter: 'br',
                    hidePoweredByJodit: true,
                    spellcheck: true,
                };
            },
            buttons: function (){
                if(this.toolbar == 'Basic'){
                    return ['bold', 'italic', 'underline', '|', 'ol', 'ul', 'link', 'unlink', 'spellcheck'];
                } else {
                    return ['source', 'fullsize', '|', 'cut', 'copy', 'paste', '|', 'bold', 'italic', 'underline', '|', 'ol', 'ul', 'link', 'unlink', 'hr', 'brush', 'eraser', '|', 'image', 'table', 'symbols', '|', 'align', 'undo', 'redo', 'spellcheck'];
                }
            },
            plugins: function(){
                return [
                    
                ];
            },
        },
        methods: {
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_value: function (value) {
                this.valueActual = value;
                this.$emit('input', value)
            },
        }
    }
</script>